import { Outlet } from "react-router-dom";

export default function About() {
    return ( 
        <div className="about">Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio totam consectetur optio reiciendis nesciunt adipisci quia illo corporis, nisi illum!
            <Outlet />
        </div>
    );
}